import React, { useEffect, useMemo, useState } from 'react'
import { Table, Select, Button } from 'antd'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../components/PageTitle'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import WorkSchedulePersonalStore from '../../stores/WorkSchedulePersonalStore'
import departmentStore from '../../stores/departmentStore'
import userStore from '../../stores/userStore'
import {
  CapitalizeString,
  DangerouslyHTML,
  TableDeppartmentComponentCustorm,
} from './WorkSchedulePersonalStyle'
import TableComponent from '../../components/Common/TableComponent'
import authenticationStore from '../../stores/authenticationStore'
import WorkSchedulePersonalHistory from './WorkSchedulePersonalHistory'

const { Option } = Select

const columns = [
  {
    title: 'STT',
    dataIndex: 'stt',
    key: 'stt',
    align: 'center',
    width: 20,
    render: (text, row, index) => {
      const obj = {
        children: (
          <CapitalizeString className="capitalize">{text}</CapitalizeString>
        ),
        props: { style: { backgroundColor: '#fff' } },
      }
      if (index % 2 === 0) {
        obj.props.rowSpan = 2
      } else {
        obj.props.rowSpan = 0
      }
      return obj
    },
  },
  {
    title: 'Họ và tên',
    dataIndex: 'name',
    key: 'name',
    render: (text, row, index) => {
      const obj = {
        children: text,
        props: { style: { backgroundColor: '#fff' } },
      }
      if (index % 2 === 0) {
        obj.props.rowSpan = 2
      } else {
        obj.props.rowSpan = 0
      }
      return obj
    },
    align: 'center',
    width: 250,
  },
  {
    title: 'Buổi',
    dataIndex: 'session',
    key: 'session',
    align: 'center',
  },
  {
    title: 'Thứ 2',
    dataIndex: 'thu2',
    width: 150,
    key: 'thu2',
    align: 'center',
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Thứ 3',
    dataIndex: 'thu3',
    key: 'thu3',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Thứ 4',
    dataIndex: 'thu4',
    key: 'thu4',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Thứ 5',
    dataIndex: 'thu5',
    key: 'thu5',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Thứ 6',
    dataIndex: 'thu6',
    key: 'thu6',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Thứ 7',
    dataIndex: 'thu7',
    key: 'thu7',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
  {
    title: 'Chủ nhật',
    dataIndex: 'cn',
    key: 'cn',
    align: 'center',
    width: 150,
    render: text => (
      <DangerouslyHTML
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          width: '100%',
          textAlign: 'left',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}>
        {text ? text.replace(/<[^>]*>/g, '').trim() : ' '}
      </DangerouslyHTML>
    ),
  },
]

const WorkScheduleDepartment = props => {
  const formatDate = date => {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  const getWeekOfDate = inputDate => {
    const year = inputDate.getFullYear()
    let firstMonday = new Date(year, 0, 1)

    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }

    let currentWeekStart = new Date(firstMonday)
    let weekNumber = 1

    while (true) {
      let weekStartDate = new Date(currentWeekStart)
      let weekEndDate = new Date(weekStartDate)
      weekEndDate.setDate(weekStartDate.getDate() + 6)
      weekEndDate.setHours(23, 59, 59, 999)

      if (inputDate >= weekStartDate && inputDate <= weekEndDate) {
        return `Tuần ${weekNumber} (${formatDate(weekStartDate)} - ${formatDate(
          weekEndDate
        )})`
      }

      currentWeekStart.setDate(currentWeekStart.getDate() + 7)
      weekNumber++

      if (currentWeekStart.getFullYear() > year) break
    }

    return 'Không tìm thấy tuần!'
  }
  const currentDate = new Date()
  const { currentUser } = authenticationStore
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear())
  const [selectedWeek, setSelectedWeek] = useState(getWeekOfDate(currentDate))
  const [workSchedulePersonalList, setWorkSchedulePersonalList] = useState([])
  const [users, setUsers] = useState([])
  const [departments, setDepartments] = useState([])
  const [weekDates, setWeekDates] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [departmentName, setDepartmentName] = useState('')
  const [selectDepartment, setSelectDepartment] = useState('')
  const [isVisibleHistory, setIsVisibleHistory] = useState(false)
  const [historyList, setHistoryList] = useState([])
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);

  useEffect(() => {
    if (currentUser?.department?.name) {
      setSelectDepartment(currentUser.department.code)
    }
  }, [currentUser])

  useEffect(() => {
    let firstMonday = new Date(selectedYear, 0, 1)
    const weekNumber = parseInt(selectedWeek.match(/Tuần (\d+)/)[1], 10)
    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }
    let weekStartDate = new Date(firstMonday)
    weekStartDate.setDate(weekStartDate.getDate() + (weekNumber - 1) * 7)
    setSelectedWeek(getWeekOfDate(weekStartDate))
  }, [selectedYear])

  const getWeeksOfYear = year => {
    const weeks = []
    let firstMonday = new Date(year, 0, 1)

    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }

    let currentWeekStart = new Date(firstMonday)
    let weekNumber = 1

    for (let i = 0; i < 52; i++) {
      let weekStartDate = new Date(currentWeekStart)
      let weekEndDate = new Date(weekStartDate)
      weekEndDate.setDate(weekStartDate.getDate() + 6)

      weeks.push(
        `Tuần ${weekNumber} (${formatDate(weekStartDate)} - ${formatDate(
          weekEndDate
        )})`
      )

      currentWeekStart.setDate(currentWeekStart.getDate() + 7)
      weekNumber++
    }

    return weeks
  }

  const generateDateBetween = (start, end) => {
    const dates = []
    const [startDay, startMonth, startYear] = start.split('/').map(Number)
    const [endDay, endMonth, endYear] = end.split('/').map(Number)

    let currentDate = new Date(startYear, startMonth - 1, startDay)
    const endDate = new Date(endYear, endMonth - 1, endDay)

    while (currentDate <= endDate) {
      const day = String(currentDate.getDate()).padStart(2, '0')
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const year = currentDate.getFullYear()

      dates.push(`${year}-${month}-${day}`)
      currentDate.setDate(currentDate.getDate() + 1)
    }
    return dates
  }

  useEffect(() => {
    if (!selectedWeek) return
    if (!selectDepartment) return

    const currentWeek = selectedWeek.match(/\((.*?)\)/)?.[1]
    if (!currentWeek) return
    if (!currentUser) return

    const [startDate, endDate] = currentWeek.split(' - ')

    const fetchData = async () => {
      try {
        setIsLoading(true)

        const response = await WorkSchedulePersonalStore.getWorkSchedulePersonalListByDepartment(
          startDate,
          endDate,
          selectDepartment
        )
        setWorkSchedulePersonalList(response.data)
        const userResponse = await userStore.getUsersByDepartment(
          selectDepartment
        )
        setUsers(userResponse.data)

        setWeekDates(generateDateBetween(startDate, endDate))
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [selectedWeek, selectDepartment, currentUser])

  const fetchDepartmentByCode = async code => {
    try {
      const response = await departmentStore.getDepartmentByCode(code)
      return response.data?.name || ''
    } catch (error) {
      console.error('Error fetching department:', error)
    }
  }

  useEffect(() => {
    if (selectDepartment) {
      fetchDepartmentByCode(selectDepartment).then(setDepartmentName)
    } else {
      setDepartmentName('')
    }
  }, [selectDepartment])

  const generatedWeeks = useMemo(() => getWeeksOfYear(selectedYear), [
    selectedYear,
  ])

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await departmentStore.getDepartmentList()
        setDepartments(response.data)
      } catch (error) {
        console.error('Error fetching departments:', error)
      }
    }

    fetchDepartments()
  }, [])

  const handleShowHistory = async username => {
    setIsLoadingHistory(true)
    const currentWeek = selectedWeek.match(/\((.*?)\)/)?.[1]
    const [startDate, endDate] = currentWeek.split(' - ')
    const response = await WorkSchedulePersonalStore.getHistory(username, startDate, endDate)
    setHistoryList(response.data);
    setIsLoadingHistory(false);
  }

  const formatWorkSchedule = (workSchedule, allUsers) => {
    const daysOfWeek = ['thu2', 'thu3', 'thu4', 'thu5', 'thu6', 'thu7', 'cn']
    const scheduleMap = workSchedule.reduce((acc, schedule) => {
      if (!acc[schedule.executedBy]) acc[schedule.executedBy] = {}
      acc[schedule.executedBy][schedule.workDate] = {
        morning: schedule.morningWork || '',
        afternoon: schedule.afternoonWork || '',
      }
      return acc
    }, {})

    let formattedData = []
    allUsers.forEach((user, index) => {
      const userSchedule = scheduleMap[user.userCode] || {}
      let morningSchedule = {
        key: `${index + 1}`,
        stt: index + 1,
        name: (
          <>
            <CapitalizeString>{user.fullName}</CapitalizeString>
            <br />({user.position})
            <br />
            <p style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                handleShowHistory(user.user_name)
                setIsVisibleHistory(true)
              }}>
              Lịch sử
            </p>
          </>
        ),
        session: 'Sáng',
      }

      let afternoonSchedule = {
        key: `${index + 1}-2`,
        stt: index + 1,
        name: (
          <>
            <CapitalizeString>{user.fullName}</CapitalizeString>
            <br />({user.position})
            <br />
            <p style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => handleShowHistory(user.user_name)}>
              Lịch sử
            </p>
          </>
        ),
        session: 'Chiều',
      }

      weekDates.forEach((date, i) => {
        const columnKey = daysOfWeek[i]
        morningSchedule[columnKey] = userSchedule[date]?.morning || ''
        afternoonSchedule[columnKey] = userSchedule[date]?.afternoon || ''
      })

      formattedData.push(morningSchedule, afternoonSchedule)
    })

    return formattedData
  }

  const formattedData = formatWorkSchedule(workSchedulePersonalList, users)

  return (
    <>
      <DashboardLayout title={'Lịch cá nhân'}>
        <Helmet>
          <title>Lịch cá nhân</title>
        </Helmet>
        <PageTitle
          location={props.location}
          title={'Lịch làm việc phòng ban'}
          hiddenGoBack></PageTitle>
        <div>
          <ContentBlockWrapper style={{ minHeight: 600 }}>
            <div>
              <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
                <Select
                  value={selectedWeek}
                  onChange={setSelectedWeek}
                  style={{ width: 300 }}
                  placeholder="Chọn tuần">
                  {generatedWeeks.map(week => (
                    <Option key={week} value={week}>
                      {week}
                    </Option>
                  ))}
                </Select>
                <Select
                  value={selectedYear}
                  onChange={setSelectedYear}
                  style={{ width: 120 }}>
                  {[
                    ...Array(
                      currentDate.getFullYear() +
                      10 -
                      (currentDate.getFullYear() - 10) +
                      1
                    ),
                  ].map((_, i) => {
                    const year = currentDate.getFullYear() - 10 + i
                    return (
                      <Option key={year} value={year.toString()}>
                        {year}
                      </Option>
                    )
                  })}
                </Select>
                <Select
                  value={departmentName}
                  onChange={setSelectDepartment}
                  style={{ width: 300 }}
                  placeholder="Chọn phòng ban">
                  {departments.map(department => (
                    <Option key={department.code} value={department.code}>
                      {department.name}
                    </Option>
                  ))}
                </Select>
              </div>
              <TableDeppartmentComponentCustorm>
                <TableComponent
                  columns={columns}
                  dataSource={formattedData}
                  pagination={false}
                  loading={isLoading}
                />
              </TableDeppartmentComponentCustorm>
            </div>
          </ContentBlockWrapper>
        </div>
      </DashboardLayout>
      <WorkSchedulePersonalHistory
        open={isVisibleHistory}
        historyList={historyList}
        isLoadingHistory={isLoadingHistory}
        onCancel={() => {
          setIsVisibleHistory(false)
          setHistoryList([])
        }}
      />
    </>
  )
}

export default WorkScheduleDepartment
